<template>
    <v-dialog v-model="dialog" width="900px" height="850px">
        <v-card>
            <!-- <p class=".title ma-2">{{ title }} </p> -->
            <v-card-title class="pa-2 px-2"><h5>{{ title }}</h5></v-card-title>
            <v-form class="px-2" ref="updAddress" v-model="updAddressValid">
                <GmapAutocomplete @place_changed='setPlace' placeholder=" Enter the address of the accommodation" size="80"/>
                <div class="pb-2"></div>
                <gmap-map :center="center" :zoom=zoom style="width:100%; height:700px;">
                    <gmap-marker :position="m.position" :draggable="true" @click="center=m.position" @drag="updateCoordinates" v-for="(m, index) in markers" :key="index" />
                </gmap-map>
            </v-form>
            <v-card-actions class="card-actions">
                <v-tooltip  bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn class="primary mx-2" small @click="centerMap" v-on="on">Center</v-btn>
                    </template>
                    <span>Center the map using the current marker location</span>
                </v-tooltip>
                
                <v-spacer></v-spacer>
                <v-btn class="primary mx-2" small @click="updGps" :disabled="!positionChanged">Save & Close</v-btn>
                <v-btn color="primary" small @click="dialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
            title: {
                type: String,
                required: false,
                default: "Show / Set Location",
            },
            latitude: {
                type: Number,
                required: true,
            },
            longitude: {
                type: Number,
                required: true,
            },
            zoom: {
                type: Number,
                required: false,
                default: 6,
            },
        },
        data() { 
            return {
                dialog: false,
                updAddressValid: false,
                googleAddress: '',
                coordinates: {},
                positionChanged: false,
                center: { lat: 45.508, lng: -73.587 },
                markers: [],
                places: [],
                currentPlace: null,
            }
        },
        methods: {
            resetMap() {
                this.dialog = false;
                this.updAddressValid = false;
                this.googleAddress = "",
                this.center = {
                    lat: 50, 
                    lng: 10,
                }
                this.zoom = 6;
                this.coordinates = {};
                this.positionChanged = false;
                this.markers = [];
                this.places = [];
                this.currentPlace = null;             
            },
            centerMap() {
                this.center = {
                    lat: this.coordinates.lat,
                    lng: this.coordinates.lng,
                }              
            },
            open() {
                this.resetMap();
                if (this.latitude != null && this.longitude != null && this.longitude != 0) {
                    this.center = {
                        lat: this.latitude, 
                        lng: this.longitude,
                    }
                    this.zoom = 8;
                }
                this.geolocate();
                this.addMarker();
                this.dialog = true;
            },
            geolocate() {
                navigator.geolocation.getCurrentPosition(position => {
                    this.center = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                });
            },
            addMarker() {
                const marker = {
                    /*
                    lat: this.currentPlace.geometry.location.lat(),
                    lng: this.currentPlace.geometry.location.lng()
                    */
                    lat: this.center.lat,
                    lng: this.center.lng
                };
                this.markers.push({ position: marker });
                this.places.push(this.currentPlace);
                this.center = marker;
                this.currentPlace = null;
            },
            updateCoordinates(location) {
                this.coordinates = {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng(),
                };
                this.positionChanged = true;
            },
            setPlace(place) {       
                this.currentPlace = place;
                const marker = {
                    lat: this.currentPlace.geometry.location.lat(),
                    lng: this.currentPlace.geometry.location.lng()
                };
                this.markers.push({ position: marker });
                this.places.push(this.currentPlace);
                this.center = marker;
                this.currentPlace = null;
            },
            updGps() {
                this.$emit("updateGPS", this.coordinates.lat, this.coordinates.lng);
                this.dialog = false;
            }        
        }
    }
</script>

